"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAppConfig = void 0;
var superstruct_1 = require("superstruct");
var isStruct_1 = require("../utils/isStruct");
var PlatformOs_1 = require("./PlatformOs");
var AppConfigStruct = (0, superstruct_1.type)({
    minVersion: (0, superstruct_1.record)(PlatformOs_1.PlatformOsStruct, (0, superstruct_1.string)()),
    storeUrl: (0, superstruct_1.record)(PlatformOs_1.PlatformOsStruct, (0, superstruct_1.string)()),
    distanceUnit: (0, superstruct_1.string)(),
    firebaseRegion: (0, superstruct_1.string)(),
    idCheck: (0, superstruct_1.type)({
        legalTitle: (0, superstruct_1.string)(),
        legalIcon: (0, superstruct_1.string)(),
        legalAge: (0, superstruct_1.number)(),
        perceivedAge: (0, superstruct_1.number)(),
    }),
    riderPerformance: (0, superstruct_1.type)({
        avgMilesPerHours: (0, superstruct_1.number)(),
        avgHandoverTimeInMinutes: (0, superstruct_1.number)(),
        avgStartNextTaskTimeInMinutes: (0, superstruct_1.number)(),
    }),
    warningInMinutes: (0, superstruct_1.type)({
        taskNotAssigned: (0, superstruct_1.array)((0, superstruct_1.number)()),
        taskNotStarted: (0, superstruct_1.array)((0, superstruct_1.number)()),
        riderNotMoving: (0, superstruct_1.array)((0, superstruct_1.number)()),
        riderNotReturning: (0, superstruct_1.array)((0, superstruct_1.number)()),
    }),
});
function isAppConfig(obj) {
    return (0, isStruct_1.isStruct)(obj, AppConfigStruct, "AppConfig");
}
exports.isAppConfig = isAppConfig;
